import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertConsignor from "../../../components/consignorComponent/insertConsignor";
import { translate } from "react-i18next";
import ReadAxios from "../../../components/axiosComponent/read";
import Axios from 'axios';
import { isEmpty } from "lodash";

class AddConsignor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "title",
      editData: {},
      billingPartyId: "",
      billingPartyBranchId: '',
      billingPartyBranchArray: []
    };
  }

  componentDidMount() {

    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }

    ReadAxios({ url: "users/consignor", readItems: { consignorId: this.props.location.state && this.props.location.state.consignorId } })
      .then((dataArray) => {
        // console.log('...', dataArray.data.resultSet)
        isEmpty(dataArray)
          ? this.setState({ loadingData: false, rowData: [] })
          : this.setState({ loadingData: false, rowData: dataArray.data.resultSet });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });

    if(this.props.location.state && this.props.location.state.consignorId){
      

      let token = localStorage.getItem('isloggedIn')
      let userId = localStorage.getItem('userId')
      let customerNo = localStorage.getItem('customerNumber')

      Axios.get(`${process.env.REACT_APP_MASTER_API}/mappings/consignor_billing_party_branch/?customerNumber=${customerNo}&userId=${userId}&consignorId=${this.props.location.state && this.props.location.state.consignorId}`, {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': token
          }
      }).then((response => {

        this.setState({
          billingPartyId: response.data.resultSet[0].billingPartyId,
          billingPartyBranchId: response.data.resultSet[0].billingPartyBranchId,
          consignorBillingPartyBranchMapId: response.data.resultSet[0].consignorBillingPartyBranchMapId
        });

        Axios.get(`${process.env.REACT_APP_MASTER_API}/billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${response.data.resultSet[0].billingPartyId}`, {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': token
          }
        }).then((response => {
          this.setState({ billingPartyBranchArray: response.data.resultSet });
        }))
          .catch(error => console.log(error))


      }))
        .catch(error => console.log(error))
    }
    
  }

  onFormSubmit = () => {
    this.props.history.push("/consignor");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar
          Title={this.props.t(this.state.title)}
          LinkName="/consignor"
        />
        <div className="m-2">
          <InsertConsignor
            editData={this.state.editData}
            billingPartyId={this.state.billingPartyId}
            billingPartyBranchId={this.state.billingPartyBranchId}
            consignorBillingPartyBranchMapId={this.state.consignorBillingPartyBranchMapId}
            billingPartyBranchArray={this.state.billingPartyBranchArray}
            onFormSubmit={this.onFormSubmit}
            usersList={this.state.rowData}
            action={this.state.title}
            consignorId={ this.props.location.state && this.props.location.state.consignorId}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate("create_consignor")(AddConsignor);
